import { render, staticRenderFns } from "./view_customers.vue?vue&type=template&id=6a1c3e7f&"
import script from "./view_customers.vue?vue&type=script&lang=js&"
export * from "./view_customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports